import Boulevard1 from "./ruko boulevard.webp";
import Boulevard2 from "./ruko boulevard (2).webp";
import Boulevard3 from "./ruko boulevard (3).webp";
import Boulevard4 from "./ruko boulevard (4).webp";

const boulevradimages = [Boulevard1, Boulevard2, Boulevard3, Boulevard4];

export default boulevradimages;
